import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { Container, Modal } from "react-bootstrap";
const DownloadUserDataModal = ({ isOpen }) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} size="sm" centered>
      <Container fluid>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress style={{ margin: "auto" }} disableShrink />
          <p style={{ paddingTop: "5%" }}>{t("download-user-data-message")}</p>
        </Modal.Body>
      </Container>
    </Modal>
  );
};

export default DownloadUserDataModal;
